import { motion } from "framer-motion";

interface LogoProps {
  className?: string;
}

export const Logo = ({ className = "" }: LogoProps) => {
  return (
    <motion.div
      className={`relative inline-block ${className}`}
      animate={{ y: [0, -8, 0] }} // gentle float
      transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
    >
      {/* Soft brand-green glow behind the logo */}
      <motion.div
        aria-hidden
        className="absolute inset-0 -z-10 rounded-full bg-[#3AB54A] blur-[60px]"
        animate={{ opacity: [0.15, 0.35, 0.15], scale: [1, 1.1, 1] }}
        transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
      />

      {/* The logo — sparkle animation is baked into the SVG file */}
      <motion.img
        src='/images/logo/logo.webp'
        alt="Logo"
        draggable={false}
        className="h-full w-auto select-none"
        animate={{ scale: [1, 1.03, 1] }} // breathing
        transition={{ duration: 2.6, repeat: Infinity, ease: "easeInOut" }}
      />

      {/* Shimmer sweep */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <motion.div
          className="h-full w-1/4 bg-gradient-to-r from-transparent via-white/20 to-transparent blur-md"
          initial={{ x: "-300%" }}
          animate={{ x: "500%" }}
          transition={{ duration: 1.8, repeat: Infinity, repeatDelay: 0.8, ease: "easeInOut" }}
        />
      </div>
    </motion.div>
  );
};